/**
 * ユーザー関連のStoreで使用するStateをここで定義する
 *
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const SmtpSettingState = Record({
  id: null,
  address: '',
  port: 0,
  domain: '',
  user_name: null,
  password: null,
  authentication: null,
  enable_starttls_auto: false,
  openssl_verify_mode: null
})

export { SmtpSettingState }
